import {
	Box,
	Container,
	Divider,
	Grid,
	IconButton,
	Link,
	makeStyles,
	Typography,
} from "@material-ui/core";
import React from "react";
import { footers, languageData, legalLinks, socialLinks } from "./data";

function Copyright() {
	return (
		<Box>
			<Container style={{ marginTop: "32px" }}>
				<Typography variant="body2" style={{ color: "white" }}>
					{"Copyright © "}
					{new Date().getFullYear()}
					Unity Technologies
					{"."}
				</Typography>
			</Container>
			<Container>
				<ul
					style={{
						display: "flex",
						flexDirection: "row",
					}}
				>
					{legalLinks.map((item) => (
						<li key={item.text}>
							<Link
								to={item.link}
								title={item.text}
								variant="subtitle2"
								style={{ color: "grey", marginRight: "16px" }}
							>
								{item.text}
							</Link>
						</li>
					))}
				</ul>
			</Container>
			<Container
				style={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-start",
					marginTop: "32px",
				}}
			>
				<Typography variant="subtitle2" style={{ color: "white", maxWidth: "600px" }} align="left">
					"Unity", Unity logos, and other Unity trademarks are trademarks or
					registered trademarks of Unity Technologies or its affiliates in the
					U.S. and elsewhere (<span style={{color:'gray', cursor:'pointer'}}>more info here</span>). Other names or brands are
					trademarks of their respective owners.
				</Typography>
			</Container>
		</Box>
	);
}
const useStyles = makeStyles((theme) => ({
	"@global": {
		ul: {
			margin: 0,
			padding: 0,
			listStyle: "none",
		},
		a: {
			textDecoration: "none",
		},
	},
	footer: {
		borderTop: `1px solid ${theme.palette.divider}`,
		marginTop: theme.spacing(8),
		paddingTop: theme.spacing(3),
		paddingBottom: theme.spacing(3),
		[theme.breakpoints.up("sm")]: {
			paddingTop: theme.spacing(6),
			paddingBottom: theme.spacing(6),
		},
	},
}));

const Footer = () => {
	const classes = useStyles();

	return (
		<div style={{ backgroundColor: "black" }}>
			<Box width="100%" className={classes.footer}>
				<Container component="footer">
					<Container
						style={{ border: "solid", borderBottom: "1px grey solid" }}
					>
						<Grid container style={{ margin: "32px auto 32px" }}>
							<Grid item xs={6}  md={6} >
								<Typography style={{ color: "white", marginBottom: "8px" }}>
									Languages
								</Typography>
								<Grid container spacing={1}>
									{languageData.map((item) => (
										<Grid item xs={4}>
											<Link href="/" style={{ color: "gray" }}>
												{" "}
												{item}
											</Link>
										</Grid>
									))}
								</Grid>
							</Grid>

							<Grid item xs={6}  md={6}>
								<Typography style={{ color: "white" }}>Social</Typography>
								<Grid container>
									{socialLinks.map((item) => {
										const { icon: Icon, link } = item;
										return (
											<IconButton
												href={link}
												size="small"
												style={{ color: "gray", marginRight: "8px" }}
											>
												<Icon />
											</IconButton>
										);
									})}
								</Grid>
							</Grid>
						</Grid>
					</Container>
					<Divider variant="middle" style={{ color: "white" }} />
					<Container style={{ marginTop: "32px" }}>
						<Grid container spacing={4} justify="space-evenly">
							{footers.map((footer) => (
								<Grid item xs={6} sm={6} lg={2} key={footer.title}>
									<Typography
										variant="subtitle1"
										style={{ color: "white" }}
										gutterBottom
									>
										{footer.title}
									</Typography>
									<ul>
										{footer.description.map((item) => (
											<li key={item.text}>
												<Link
													href={item.link}
													variant="subtitle2"
													style={{ color: "grey" }}
												>
													{item.text}
												</Link>
											</li>
										))}
									</ul>
								</Grid>
							))}
						</Grid>
					</Container>
					<Box width="100%">
						<Copyright />
					</Box>
				</Container>
			</Box>
		</div>
	);
};
export default Footer;
